// @ts-nocheck
import { DropZone } from "./WebSite.Page.Component.DropZone";

function retrieveFile(uri, name, callback) {
    var blob = null;
    var request = new XMLHttpRequest();
    request.responseType = "blob";

    request.open("GET", uri, true);
    request.onload = function() {
        blob = request.response;
        callback(new File([blob], name, {type: "application/octet-stream", lastModified: Date.now()}));
    }
    request.send();
}

export class FileDropZone extends DropZone {
  constructor(element) {
    super(element);
  }

  canDrop(event) {
    if (event.dataTransfer.types) {
      for (const type of event.dataTransfer.types) {
        if (type === "Files" || type === "file")
          return true;
      }
    }

    return false;
  }

  handleDrop(event) {
    if (event.dataTransfer.files.length > 0)
      this.handleFiles(event.dataTransfer.files);
    else
      retrieveFile(event.dataTransfer.getData("file"), event.dataTransfer.getData("filename"), (file) => { this.handleFiles([file]); });
  }

  validateFile(file, accept) {
    let valid;

    if (accept.length > 0) {
      const allowedTypes = accept.split(",");
      let index = 0;

      valid = false;

      while (!valid && index < allowedTypes.length) {
        const allowedType = allowedTypes[index];

        if (allowedType.startsWith("."))
          valid = file.name.endsWith(allowedType);
        else if (allowedType === "audio/*")
          valid = file.type.startsWith("audio/");
        else if (allowedType === "video/*")
          valid = file.type.startsWith("video/");
        else if (allowedType === "image/*")
          valid = file.type.startsWith("image/");
        else
          valid = file.type === allowedType;

        index++;
      }
    }
    else
      valid = true;

    return valid;
  }
}
